import React, { useEffect } from "react";
import Checkmark from "../../assets/images/checkmark.png";
import LogoDogSit from "../../assets/images/logo-dog-sit.png";
import PrimaryButton from "../../components/button/PrimaryButton";
import PopupQuestionnaireSuccess from "../../components/popup/PopupQuestionnaireSuccess";
import { useLocation, useNavigate } from "react-router-dom";
import SecondaryButton from "../../components/button/SecondaryButton";
import { useSelector } from "react-redux";
import TopLogo from "../../components/layout/TopLogo";
import { SearchId } from "../../services/SearchId";
import errorCircle from "../../assets/images/icon/error-circle.svg";
import { useLiff } from "react-liff";
import SuccessStyle from "../../assets/images/success-style.png";

export default function QuestionnaireNotFoundCat() {
  const store = useSelector((state) => state.questionnaire);
  const [openCancelPopup, setOpenCancelPopup] = React.useState(true);
  const [memberId, setMemberId] = React.useState(true);
  const navigate = useNavigate();

  const { liff } = useLiff();
  const lineId = liff.getDecodedIDToken().sub;

  const isMember = memberId ?? false;
  const isShowPoint = store["points"] !== 0;

  useEffect(() => {
    getSearchId();
    //
  }, []);

  async function getSearchId() {
    return await SearchId({
      params: { lineId: lineId || null , species : 2 },
    })
      .then(async (response) => {
        if (!response.data.body.memberId) {
          setMemberId(null);
        } else {
          setMemberId(response.data.body.memberId);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  return (
    <>
      <TopLogo />
      {/* {JSON.stringify(store)} */}
      <div
        style={{
          minHeight: "calc(100vh - 60px)",
          padding: "20px",
          background: "linear-gradient(129.17deg, #213468 22.83%, #213468 36.49%, #1D4164 41.4%, #15645A 50.69%, #079D4A 63.25%, #07A14A 63.8%, #07A14A 77.45%)",

        }}
      >
        <img
          src={SuccessStyle}
          alt="logo"
          style={{ width: "70%", float: "right" }}
          className="mt-[-20px] mr-[-20px]"
        />
        <div className="mt-[40px] w-full" style={{
          position: "fixed",
          left: "50%",
          transform: "translate(-50%, 0)"
        }}>
          <img
            className="mx-auto mt-[100px]"
            src={errorCircle}
            alt="logo"
            style={{ maxWidth: "52px" }}
          />
          <div className="text-white text-center text-[36px] mt-[10px] leading-[100%]">
            ขออภัย
          </div>
          <div className="text-white text-center text-[24px] leading-[100%]">
            กิจกรรมนี้สิ้นสุดแล้ว
          </div>

          {false && (
            <div className="absolute w-full bottom-[15px] left-0 text-center mt-[50px]">
              <div className="my-4">
                {isMember ? (
                  <PrimaryButton
                    variant="contained"
                    className="w-[70%] !bg-[#082e683d]"
                    onClick={() => {
                      navigate("/my-point");
                    }}
                  >
                    กลับไปหน้าแลกของรางวัล
                  </PrimaryButton>
                ) : (
                  <PrimaryButton
                    variant="contained"
                    className="w-[70%] !bg-[#082e683d]"
                    onClick={() => {
                      navigate("/register");
                    }}
                  >
                    ลงทะเบียน One And Done
                  </PrimaryButton>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
